import { useNavigate } from 'react-router-dom';
import { useEntities } from '../../../api/entities';

export default function RiskOverviewWidget() {
  const navigate = useNavigate();
  const { data: entitiesData } = useEntities({
    page: 1,
    page_size: 10,
    sort_by: 'risk_score',
    sort_order: 'desc',
  });

  const topRiskEntities = entitiesData?.items ?? [];

  const getRiskColor = (score: number): string => {
    if (score >= 0.8) return 'bg-red-500';
    if (score >= 0.6) return 'bg-orange-500';
    if (score >= 0.4) return 'bg-amber-500';
    if (score >= 0.2) return 'bg-blue-500';
    return 'bg-green-500';
  };

  const getRiskTextColor = (score: number): string => {
    if (score >= 0.8) return 'text-red-400';
    if (score >= 0.6) return 'text-orange-400';
    if (score >= 0.4) return 'text-amber-400';
    if (score >= 0.2) return 'text-blue-400';
    return 'text-green-400';
  };

  return (
    <div className="glass-panel p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-300">Top 10 Risques</h3>
        <button
          onClick={() => navigate('/entities')}
          className="text-xs text-cyber-cyan hover:underline"
        >
          Voir tout
        </button>
      </div>
      <div className="flex-1 overflow-y-auto space-y-2 min-h-0">
        {topRiskEntities.length > 0 ? (
          topRiskEntities.map((entity) => (
            <div
              key={entity.id}
              onClick={() => navigate(`/entities?selected=${entity.id}`)}
              className="flex items-center gap-3 cursor-pointer hover:bg-surface-tertiary/30 rounded-lg p-2 transition-colors"
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-200 truncate">{entity.name}</p>
                <p className="text-[10px] text-gray-500 capitalize">{entity.type.replace('_', ' ')}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <div className="w-20 h-1.5 rounded-full bg-surface-tertiary overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-500 ${getRiskColor(entity.risk_score)}`}
                    style={{ width: `${Math.round(entity.risk_score * 100)}%` }}
                  />
                </div>
                <span className={`text-xs font-mono font-semibold w-8 text-right ${getRiskTextColor(entity.risk_score)}`}>
                  {Math.round(entity.risk_score * 100)}
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500 text-center py-8">Aucune donnee</p>
        )}
      </div>
    </div>
  );
}
